package com.example.mystybag.sharedmodels.mobileAdmin.database

enum class UsersCredentialTypes(val value: Int) {
    STANDARD(1),
    GOOGLE(2),
    FACEBOOK(3),
    APPLE(4)
}